var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('h1',[_vm._v("Thank You")]),_c('h2',[_vm._v("We have received your message and will be in touch!")]),_c('router-link',{staticClass:"button",attrs:{"to":{ name: 'Profile' }}},[_vm._v(" View Profile ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }